import { supabaseClient } from "@/lib/supabase";
import { useAuth } from "@/utils/auth";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { toast } from "sonner";
import useProfileProgress from "../../profile/hooks/useProfileProgress";

const updatePassword = async (newPassword: string) => {
	const { data, error } = await supabaseClient.auth.updateUser({
		password: newPassword,
	});
	if (error) throw error;
	return data;
};

const useUpdatePasswordMutation = () => {
	const auth = useAuth();
	const navigate = useNavigate();
	const { incomplete } = useProfileProgress(auth.id);
	return useMutation({
		mutationFn: async (password: string) => {
			return updatePassword(password);
		},
		onError: (error) => {
			toast.error(error.message);
		},
		onSuccess: () => {
			toast.success("Password updated successfully!");
			incomplete
				? navigate({ to: "/onboarding/name" })
				: navigate({ to: "/profile" });
		},
		onSettled: () => {},
	});
};

export default useUpdatePasswordMutation;
